module.exports = __webpack_public_path__ + "media/images/distinguishedservicecross-e77cc9ef160b8bf58b363696918f93e4.jpg";